export default function () {
  const ownerPagesFolders = ['/owner', '/propietario']
  const cottageDetailPrefix = '/casas-rurales/'
  const authRoutes = ['/login', '/viajero/registro', '/propietario/casa/nueva']
  const privateRoutes = ['/private', '/outings']
  const ownerRegisterRoute = '/propietario/casa/nueva'
  const newOwnerLanding = '/aumenta-tus-reservas'
  const signupAppRoute = '/signup-app'

  const isOwnerRoute = (url: string): boolean => {
    return ownerPagesFolders.some(folder => url.startsWith(folder))
  }

  const isAuthRoute = (path: string): boolean => {
    return authRoutes.includes(path)
  }

  const isPrivateRoute = (path: string): boolean => {
    return privateRoutes.some(route => path.startsWith(route))
  }

  const isOwnerRegisterRoute = (path: string): boolean => {
    return path === ownerRegisterRoute
  }

  const isNewOwnerLandingUrl = (url: string): boolean => {
    return url.includes(newOwnerLanding)
  }

  const isSignupAppRoute = (path: string): boolean => {
    return path === signupAppRoute
  }

  const isCottageDetailRoute = (path: string): boolean => {
    return path.startsWith(cottageDetailPrefix)
  }

  return {
    isOwnerRoute,
    isAuthRoute,
    isPrivateRoute,
    isOwnerRegisterRoute,
    isNewOwnerLandingUrl,
    isSignupAppRoute,
    isCottageDetailRoute,
  }
}
